// extracted by mini-css-extract-plugin
module.exports = {"container":"EmojiConfetti_container__udSZR","particle":"EmojiConfetti_particle__yAKYm"};